const changeDelimiter = store => async (state, csvDelimiter) => {
    const newUser = {
        ...state.user,
        csvDelimiter,
    };
    localStorage.setItem('mvc-user', JSON.stringify(newUser));
    store.setState(
        {
            ...state,
            user: newUser,
        },
        true,
    );
};

export default changeDelimiter;
